import { render, staticRenderFns } from "./PanelSkillConfig.vue?vue&type=template&id=977cdb78&scoped=true&"
import script from "./PanelSkillConfig.vue?vue&type=script&lang=js&"
export * from "./PanelSkillConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977cdb78",
  null
  
)

export default component.exports